import React from 'react';
import Pagination from '../../../components/pagination';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';

function ArticleTable({
  handleSort,
  paginationOptions,
  handlePageChange,
  loading,
  error,
  data,
  totalRows,
  handleRefresh
}) {
  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th className="cursor-pointer" onClick={() => handleSort('title')}>
              Judul
              {paginationOptions.sort_field === 'title' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="cursor-pointer" onClick={() => handleSort('type')}>
              Jenis
              {paginationOptions.sort_field === 'type' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="cursor-pointer" onClick={() => handleSort('status')}>
              Status
              {paginationOptions.sort_field === 'status' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="cursor-pointer" onClick={() => handleSort('created_at')}>
              Tanggal Dibuat
              {paginationOptions.sort_field === 'updated_at' && (
                <span className="ml-20">
                  <i
                    className={`fa fa-caret-${paginationOptions.sort_value === 'asc' ? 'down' : 'up'} text-blue-1 fs-5`}
                  />
                </span>
              )}
            </th>
            <th className="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="6">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center" colSpan="6">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="6">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={handleRefresh}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td width="620">
                <div className="d-flex align-items-center">
                  <span className="fw-500">{row.title ?? '-'}</span>
                </div>
              </td>
              <td>
                <span className="fw-500">{row.type === 'PAGE' ? 'Page' : 'Blog'}</span>
              </td>
              <td>
                <span className="fw-500">{row.status === 'PUBLISHED' ? 'Published' : 'Draft'}</span>
              </td>
              <td>{format(new Date(row.created_at), 'dd/MM/yyyy hh:mm')}</td>
              <td className="text-center pe-0">
                <Link
                  to={`/article/details/${row.slug}`}
                  className="fw-600 btn btn-success text-white btn-sm">
                  <i className="fa fa-pencil mr-4"></i>
                  Edit
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        currentPage={paginationOptions.page}
        totalRows={totalRows}
        rowsPerPage={paginationOptions.limit}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default ArticleTable;
